import React from "react";
import { Clock, MessagesSquare, ShieldCheck, Layers3 } from "lucide-react";

const ITEMS = [
  { icon: Clock, title: "Rask behandling", text: "Vi prioriterer rask diagnostikk og kort ventetid der det er mulig." },
  { icon: MessagesSquare, title: "Tydelig kommunikasjon", text: "Du får klar informasjon om feil, løsning og pris før vi starter." },
  { icon: ShieldCheck, title: "Kvalitetsdeler", text: "Vi bruker deler av god kvalitet for et pålitelig resultat." },
  { icon: Layers3, title: "Reparasjon av flere typer enheter", text: "Mobil, nettbrett, Mac og PC – alt på ett sted." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 sm:py-24 bg-navy" data-testid="why-choose-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-warm">Fordeler</span>
          <h2 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-white">
            Derfor velger kunder MobilHub
          </h2>
        </div>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {ITEMS.map((it) => (
            <div
              key={it.title}
              className="rounded-xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm hover:bg-white/10 transition-colors"
              data-testid={`benefit-${it.title}`}
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-electric text-white">
                <it.icon className="w-6 h-6" strokeWidth={1.8} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-white">{it.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-300">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
